import Util from '@/helper/Utility.js';

export function AIARedeemConfigModel () {
    this.info1 = null;

    this.setTransfer = function () {
        if (this.info1)
            this.info1 += '|';

        this.info1 = 'type_transfer';
    };

    this.setCaption = function (caption) {
        if (!caption) return;

        var captions = caption.split('|');
        captions.filter((captionVal, captionIndex) => {
            if (captionVal.indexOf('tel.') >= 0) {
                captions.splice(captionIndex, 1);
            }
        });

        for (var captionItem of captions) {
            if (this.info1)
                this.info1 += `|${captionItem}`;
            else
                this.info1 = captionItem;
        }
    };

    this.getParams = function () {
        var params = {
            info1: this.info1,
        };

        params = Util.cleanObjectNullKey(params);
        return params;
    };
}
